import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal, WritableSignal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CallbackType } from '@shared/models/callback-type';
import { ToastType } from '@shared/models/toast-type';
import { FormCallbackService } from '@shared/services/form-callback.service';
import { ToastStoreService } from '@shared/stores/toast-store.service';
import { FormContainerComponent } from '@shared/ui-components/form-container/form-container.component';
import { FormContainerConfig } from '@shared/ui-components/form-container/shared/form-container-config';
import { FormFieldComponent } from '@shared/ui-components/form-field/form-field.component';
import { InputDirective } from '@shared/ui-components/form-field/shared/input.directive';
import { SubmitButtonComponent } from '@shared/ui-components/submit-button/submit-button.component';
import { EvlandValidators } from '@shared/utils/validators';
import { IMaskDirective } from 'angular-imask';
import { LazyLoadImageModule } from 'ng-lazyload-image';
// import { ReCaptchaV3Service } from 'ng-recaptcha';
import { finalize } from 'rxjs';

declare var gtag;

@Component({
  selector: 'evland-questions-full-width-form',
  templateUrl: './questions-full-width-form.component.html',
  styleUrls: [ './questions-full-width-form.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    InputDirective,
    IMaskDirective,
    ReactiveFormsModule,
    LazyLoadImageModule,
    FormContainerComponent,
    FormFieldComponent,
    SubmitButtonComponent
  ],
})
export class QuestionsFullWidthFormComponent {
  formConfig: FormContainerConfig = {
    header: {
      title: $localize`Залишились питання?`,
      hint: $localize`Задайте їх нашому консультанту`
    }
  };
  form: UntypedFormGroup;
  isSubmitting: WritableSignal<boolean> = signal(false);

  #cdr = inject(ChangeDetectorRef);
  #fb = inject(UntypedFormBuilder);
  #formCallbackService = inject(FormCallbackService);
  // #recaptchaV3Service = inject(ReCaptchaV3Service);
  #toastStore = inject(ToastStoreService);

  constructor() {
    this.createForm();
  }

  onSubmit(): void {
    if (this.form.invalid || this.form.pristine || this.isSubmitting()) return;

    this.isSubmitting.set(true);

    const { name, contactNumber } = this.form.value;

    // this.#recaptchaV3Service.execute('QuestionsFormSubmit')
    this.#formCallbackService.submit({
      subject: $localize`Запитання`,
      name,
      contact_number: contactNumber,
    })
      .pipe(
        // switchMap((token: string) =>  this.formCallbackService.submit({
        //   recaptha: token,
        //   subject: $localize`Запитання`,
        //   name,
        //   contact_number: contactNumber,
        // })),
        finalize(() => this.isSubmitting.set(false)),
      )
      .subscribe(
        () => {
          try {
            gtag('event', CallbackType.Question, {
              'value': 'none',
            });
          } catch (e) {
            console.error('gtag not found');
          }

          this.#toastStore.show({
            text: $localize`Запит успішно надіслано. Наші менеджери незабаром зв'яжуться з вами`,
            type: ToastType.Success
          });
          this.form.reset();
        },
        () => this.#toastStore.show({
          text: $localize`Помилка! Перевірте ще раз форму або спробуйте пізніше`,
          type: ToastType.Error
        }),
      );
  }

  private createForm(): void {
    this.form = this.#fb.group({
      name: [ '', Validators.required ],
      contactNumber: [ '', [ Validators.required, EvlandValidators.phoneNumber ] ],
    });
  }
}
